import {
  addOrder, //发货列表
  putShipping,//提交发货
  getShipping,//物流列表
  delShipping,//删除物流
  detailsShipping,//物流详情
  addOrderShipping,//查询可追加的
  } from "@/api/logistics.js";
  export default {
    state: {

    },
    actions: {
      // 发货列表
      addOrderAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          addOrder(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 查询可追加
      addOrderShippingAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          addOrderShipping(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 物流详情
      detailsShippingAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          detailsShipping(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 发货列表
      getShippingAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          getShipping(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 删除物流
      delShippingAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          delShipping(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      // 提交发货
      putShippingAction({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          putShipping(params)
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },

    },
    mutations: {

    },
    getters: {}
  };
  


// WEBPACK FOOTER //
// ./src/store/module/logistics.js